import $ from 'jquery';
import Vue from 'vue';
import "custom-event-polyfill";

export function initializeFoundation(Foundation) {
    /** Extend jquery with foundation */
    Foundation.addToJquery($);

    /** Initialize foundation */
    $(document).foundation();
}

export function initializeVue(){
    const vueComponents = document.querySelectorAll('[data-vue]'),
    event = new CustomEvent('vue_loaded');

    if (vueComponents.length > 0) {
        for (var i = 0; i < vueComponents.length; i++) {
            let element = vueComponents[i];
            let moduleData = JSON.parse(element.getAttribute('data-module-options')) || {};
            
            new Vue({ el: element, data: moduleData,mounted() {
                this.$nextTick(() => {
                    document.dispatchEvent(event);
                });
            }, });
        }
    } else {
        document.dispatchEvent(event);
    }
}

/** Initializes vue components on the document */
export function initializeVueComponents(){
    const moduleElements = document.querySelectorAll('[data-module]');

    for (var i = 0; i < moduleElements.length; i++) {
        const el = moduleElements[i];
        let result = initializeElementModule(el);

        if(!result){
            break;
        }
    }
}

/**
 * Initializes the element module
 * @param {string} elementId 
 */
export function initializeModule(elementId){
    return initializeElementModule(document.getElementById(elementId));
}

/**
 * Initializes the element module
 * @param {HTMLElement} el 
 */
function initializeElementModule(el){
    let result = true;
    const name = el.getAttribute('data-module');
    let options = el.getAttribute('data-module-options');
    let manual = el.getAttribute('data-module-manual');

    if (name === '') {
        if (DEBUG) {
            console.warn('Name ' + name + ' was not a valid module name.');
        }
        result = false;
    }

    if(result) {
        if (JSON.parse(options)) {
            // Options are succesfully parseable to json
            options = JSON.parse(options);
        }
        else if (typeof options !== 'undefined' && options !== null) {
            // Invalid options sent
            if (DEBUG) {
                console.warn('The options object supplied with ' + name + ' module seems to be invalid json.');
            }
            result = false;
        }
        else {
            // No options provided.
            options = {}; // fallback
        }
        
        if (!manual) {
            const Module = require(`./${name}`).default;
            new Module({ el: el,  data: options });
        } else {
            console.log('Module ' + name + ' is set to manual loading. Skipping.');
        }
    }

    return result;
}

/** Enable HRM */
if (module.hot) {
    module.hot.accept();
}